import React, { forwardRef, memo, useCallback } from "react";
import _ from "lodash";
import { Input, Select } from "antd";
import { disabledFields } from "./Constant";
import { useDispatch, useSelector } from "react-redux";
import EmbryologyEmbryoDevelopmentTable from "./EmbryologyEmbryoDevelopmentTable";

// const oocyteValidationSchema = Yup.object().shape({
//   no_of_oocytes: Yup.number()
//     .nullable()
//     .transform((value, originalValue) => (originalValue === "" ? 0 : value))
//     .test(
//       "combined-required-and-valid",
//       "Invalid no_of_oocytes",
//       function (value) {
//         const { plannedCycle } = this.options.context || {};
//         const { total_m2, total_m1, total_m2_used, total_m1_used } =
//           this.parent;

//         const toNum = (val) => {
//           const num = Number(val);
//           return isNaN(num) ? 0 : num;
//         };

//         const plannedCycleHasODorED =
//           plannedCycle?.includes("OD") || plannedCycle?.includes("ED");

//         // Check required condition
//         if (plannedCycle && !plannedCycleHasODorED) {
//           if (
//             value !== 0 &&
//             (value === undefined || value === null || value === "" || !value)
//           ) {
//             return this.createError({
//               message: "Required when cycle is not OD or ED",
//             });
//           }
//         }

//         const sum = [total_m2, total_m1, total_m2_used, total_m1_used]
//           .map(toNum)
//           .reduce((a, b) => a + b, 0);

//         const currentValue = toNum(value);

//         if (!currentValue || !sum || currentValue >= sum) {
//           return true;
//         } else {
//           return this.createError({
//             message: "Should be >= M1+M2+UsedM1+UsedM2",
//           });
//         }
//       }
//     ),
//   total_m2: Yup.number()
//     .nullable()
//     .transform((value, originalValue) => (originalValue === "" ? 0 : value))
//     .test("m2-valid", "M2 exceeds limit", function (value) {
//       const patient_detail = this.options.context?.patient_detail;
//       const remain_m1 = patient_detail?.ivf?.remain_m1;
//       const remain_m2 = patient_detail?.ivf?.remain_m2;
//       const remainM2 = remain_m2 + 1;

//       if (remain_m1 === 0 && remain_m2 === 0) {
//         return this.createError({ message: "Unavailable" });
//       }

//       if (remain_m2 === null) {
//         return true;
//       }

//       // if (value > remainM2) {
//       //   return this.createError({
//       //     message: "M2 exceeds limit"
//       //   });
//       // }

//       if (value >= remainM2) {
//         return this.createError({
//           message: `Allow < ${remainM2}`,
//         });
//       }

//       return true;
//     }),
//   total_m1: Yup.number()
//     .nullable()
//     .transform((value, originalValue) => (originalValue === "" ? 0 : value))
//     .test("m1-valid", "M1 exceeds limit", function (value) {
//       const patient_detail = this.options.context?.patient_detail;
//       const remain_m1 = patient_detail?.ivf?.remain_m1;
//       const remain_m2 = patient_detail?.ivf?.remain_m2;
//       const remainM1 = remain_m1 + 1;

//       if (remain_m1 === null) {
//         return true;
//       }

//       if (remain_m1 === 0 && remain_m2 === 0) {
//         return this.createError({
//           message: "Unavailable",
//         });
//       }

//       // if (value > remainM1) {
//       //   return this.createError({
//       //     message: "M1 exceeds limit"
//       //   });
//       // }

//       if (value >= remainM1) {
//         return this.createError({
//           message: `Allow < ${remainM1}`,
//         });
//       }

//       return true;
//     }),
//   total_m1_used: Yup.number().nullable(),
//   total_m2_used: Yup.number().nullable(),
//   gv: Yup.string(),
//   atretic: Yup.string(),
//   fert: Yup.string(),
//   cleaved: Yup.string(),
//   unfert: Yup.string(),
//   degenerated: Yup.string(),
//   kept_for_blastocyst: Yup.string(),
//   total_blastocyst: Yup.string(),
// });

// const oocyteTableSchema = Yup.object().shape({
//   anesthesia_given_by: Yup.string().nullable(),
//   anesthesia_given_by_other: Yup.string(),
//   opu_done_by: Yup.string().nullable(),
//   opu_done_by_other: Yup.string().nullable(),
//   tesa_pesa_done_by: Yup.string().nullable(),
//   tesa_pesa_done_by_other: Yup.string().nullable(),
//   denudation_done_by: Yup.string().nullable(),
//   denudation_done_by_other: Yup.string(),
//   icsi_ivf_done_by: Yup.string().nullable(),
//   icsi_ivf_done_by_other: Yup.string().nullable(),
//   assisted_by: Yup.string().nullable(),
//   assisted_by_other: Yup.string().nullable(),
//   lmp: Yup.string(),
//   opu_date: Yup.string().nullable(),
//   opu_time: Yup.string().nullable(),
//   actual_opu_time: Yup.string().nullable(),
//   denudation_time: Yup.string().nullable(),
//   icsi_ivf_time: Yup.string().nullable(),
//   lh: Yup.string(),
//   e2: Yup.string(),
//   embryo_dev_incubator: Yup.string().nullable(),
//   embryo_dev_incubator_other: Yup.string().nullable(),
//   embryo_dev_culture_media: Yup.string().nullable(),
//   embryo_dev_culture_media_other: Yup.string().nullable(),
//   embryo_dev_batch_no_exp_date: Yup.string(),
//   embryo_dev_pgt: Yup.string().nullable(),
//   add_on: Yup.array().of(Yup.string()).nullable(),
//   progesterone: Yup.string(),
//   amh: Yup.string(),
//   day_0_date: Yup.string().nullable(),
//   day_0_time: Yup.string().nullable(),
//   day_0_hrs_post_icsi: Yup.string(),
//   day_1_date: Yup.string().nullable(),
//   day_3_date: Yup.string().nullable(),
//   day_5_date: Yup.string().nullable(),
//   day_6_date: Yup.string().nullable(),
//   day_7_date: Yup.string().nullable(),
//   freezing_media: Yup.string().nullable(),
//   freezing_media_other: Yup.string().nullable(),
//   vitrification_batch_no_exp_date: Yup.string(),
//   vitrification_devices: Yup.string().nullable(),
//   vitrification_devices_other: Yup.string().nullable(),
//   total_goblet: Yup.string(),
//   total_straw: Yup.string(),
//   tank_no: Yup.string(),
//   cannister_no: Yup.string(),
//   oocytes: Yup.array().of(oocyteValidationSchema),
// });

const EmbryologyProcedureDetails = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const {
    values,
    setValues,
    setFieldValue,
    errors,
    touched,
    handleBlur,
    handleChange,
    setFieldError,
    selectedLocation,
    selectedModule,
    selectedPatient,
  } = props;

  const {
    // doctorList,
    patientList,
    embryologyData,
    embryologyDetails,
    patientDetailsEDS,
    partnerDetailsEDS,
    eggsToPatientList,
    eggsToIvfOptionTemp,
    eggsToDonorPatientList,
  } = useSelector(({ embryologyData }) => embryologyData);
  const { IvfFlowsheetList } = useSelector(({ ivfFlowSheet }) => ivfFlowSheet);
  const { moduleWiseDropdownData } = useSelector(({ common }) => common);

  const plannedCycleHasOD = embryologyDetails?.cycle_type?.includes("OD");

  // const plannedCycleHasODorED = useMemo(() => {
  //   return (
  //     IvfFlowsheetList?.planned_cycle?.includes("OD") ||
  //     IvfFlowsheetList?.planned_cycle?.includes("ED")
  //   );
  // }, [IvfFlowsheetList]);

  // const validateOocytes = async (values) => {
  //   const errors = {};

  //   if (!values.oocytes || !Array.isArray(values.oocytes)) {
  //     return errors;
  //   }

  //   for (let i = 0; i < values.oocytes.length; i++) {
  //     try {
  //       await oocyteValidationSchema.validate(values.oocytes[i], {
  //         context: {
  //           patient_detail: values.oocytes[i].patient_detail,
  //           // plannedCycleHasODorED: plannedCycleHasODorED
  //           plannedCycle: IvfFlowsheetList?.planned_cycle,
  //           // eggs: /* your value */,
  //           // cycleType: /* your value */
  //         },
  //         abortEarly: false,
  //       });
  //     } catch (err) {
  //       if (err.inner) {
  //         err.inner.forEach((error) => {
  //           if (!errors.oocytes) errors.oocytes = [];
  //           if (!errors.oocytes[i]) errors.oocytes[i] = {};
  //           errors.oocytes[i][error.path] = error.message;
  //         });
  //       }
  //     }
  //   }

  //   return errors;
  // };

  // const convertToCommonDateFormat = (dateString) => {
  //   const possibleFormats = [
  //     "DD/MM/YYYY",
  //     "MM/DD/YYYY",
  //     "YYYY-MM-DD",
  //     "DD-MM-YYYY",
  //     "MM-DD-YYYY",
  //     "YYYY/MM/DD",
  //     moment.ISO_8601, // For ISO formatted dates
  //   ];

  //   const parsedDate = moment(dateString, possibleFormats, true); // 'true' for strict parsing
  //   if (!parsedDate.isValid()) {
  //     return null;
  //   }

  //   return parsedDate.format("YYYY-MM-DD");
  // };

  // const handleSubmitForm = useCallback(
  //   (values) => {
  //     if (embryologyDetails?.ivf_flow_id) {
  //       const donorBy = [];
  //       const eggsBy = [];
  //       const eggsBydonor = [];
  //       const eggsIvfId = [];
  //       const eggsIvfDonorId = [];
  //       let generatedEggsToIVFId = [];
  //       let updatedEggsToPatients = [];

  //       const isProfessionalDonorPlannedCycle =
  //         IvfFlowsheetList?.planned_cycle?.includes("Professional Donor");

  //       const { oocytes, ...restProcedureDetails } = values;

  //       const updatedEmbryoTableData = oocytes?.map((item) => {
  //         if (item?.patient_detail) {
  //           if (item?.patient_detail.isDonor) {
  //             eggsBydonor.push({
  //               id: item?.patient_detail.patientId,
  //               name: item?.patient_detail.patientName,
  //               disable: true,
  //             });
  //             eggsIvfDonorId.push({
  //               _id: item?.patient_detail?.ivf._id,
  //               ivf_id: item?.patient_detail?.ivf.ivf_id,
  //               disable: true,
  //             });
  //           } else {
  //             if (
  //               item?.patient_detail &&
  //               selectedPatient?._id !== item?.patient_detail?.patientId
  //             ) {
  //               eggsBy.push({
  //                 id: item?.patient_detail.patientId,
  //                 name: item?.patient_detail.patientName,
  //                 disable: true,
  //               });
  //               eggsIvfId.push({
  //                 _id: item?.patient_detail?.ivf._id,
  //                 ivf_id: item?.patient_detail?.ivf.ivf_id,
  //                 disable: true,
  //               });
  //             }
  //           }
  //         }

  //         return {
  //           ...item,
  //           icsi_done_by_embryo_table: plannedCycleHasOD
  //             ? item?.icsi_done_by_embryo_table?.value || null
  //             : null,
  //           reference_ivf_id: isProfessionalDonorPlannedCycle
  //             ? selectedPatient?._id
  //             : item?.patient_detail?.isDonor
  //             ? patientDetailsEDS?.eggs_donor === "Donor Fresh" ||
  //               patientDetailsEDS?.eggs_donor === "Donor Thawed"
  //               ? item?.patient_detail?.ivf._id
  //               : null
  //             : patientDetailsEDS?.eggs === "Donor Fresh" ||
  //               patientDetailsEDS?.eggs === "Donor Thawed"
  //             ? item?.patient_detail?.ivf._id
  //             : null,

  //           embryo: item.embryo.map((e) => {
  //             const date = convertToCommonDateFormat(e?.date_of_freezing);
  //             const oocytes_quality = _.map(e?.oocytes_quality, "value");

  //             return {
  //               ...e,
  //               oocytes_quality,
  //               embryo_grade: e?.embryo_grade?.value || null,
  //               fert_check: e?.fert_check?.value || null,
  //               goblet_color: e?.goblet_color?.value || null,
  //               stage_of_development: e?.stage_of_development?.value || null,
  //               status: e?.status?.value || null,
  //               straw_color: e?.straw_color?.value || null,
  //               vitrified_by: e?.vitrified_by?.value || null,
  //               date_of_freezing: e?.date_of_freezing
  //                 ? moment(date, "YYYY-MM-DD").format("YYYY-MM-DD")
  //                 : null,
  //             };
  //           }),
  //         };
  //       });

  //       // if (patientList) {
  //       // patientList?.map((patient) => {
  //       //   if (patientDetailsEDS?.eggs_to?.includes(patient._id)) {
  //       //     donorBy.push({
  //       //       id: patient._id,
  //       //       name: patient.patient_full_name
  //       //     });
  //       //   }
  //       // }, []);
  //       // }

  //       if (isProfessionalDonorPlannedCycle) {
  //         const selectedEggsToIvfId = eggsToIvfOptionTemp?.filter((item) =>
  //           patientDetailsEDS.eggs_to_ivf_id.includes(item._id)
  //         );

  //         updatedEggsToPatients =
  //           eggsToPatientList?.map((patient) => {
  //             return {
  //               id: patient._id,
  //               name: patient.patient_full_name,
  //             };
  //           }) || [];

  //         generatedEggsToIVFId = selectedEggsToIvfId.map((item) => ({
  //           _id: item._id,
  //           ivf_id: item.ivf_id,
  //           disable: true,
  //         }));
  //       }

  //       const updatedEggsToDonorPatients =
  //         eggsToDonorPatientList?.map((patient) => {
  //           return {
  //             id: patient._id,
  //             name: patient.patient_full_name,
  //           };
  //         }) || [];

  //       const payloadObj = {
  //         ...patientDetailsEDS,
  //         ...partnerDetailsEDS,
  //         ...restProcedureDetails,
  //         embryology_count: updatedEmbryoTableData,
  //         eggs_by: eggsBy,
  //         eggs_by_donor: eggsBydonor,
  //         eggs_by_ivf_id: eggsIvfId,
  //         eggs_by_ivf_id_donor: eggsIvfDonorId,
  //         // eggs_to: donorBy,
  //         eggs_to: updatedEggsToPatients,
  //         eggs_to_ivf_id: generatedEggsToIVFId,
  //         eggs_to_donor: updatedEggsToDonorPatients,
  //         icsi_ivf_done_by:
  //           plannedCycleHasOD || values?.icsi_ivf_done_by === "Other"
  //             ? null
  //             : values?.icsi_ivf_done_by,
  //         opu_done_by:
  //           values?.opu_done_by === "Other" ? null : values?.opu_done_by,
  //         tesa_pesa_done_by:
  //           values?.tesa_pesa_done_by === "Other"
  //             ? null
  //             : values?.tesa_pesa_done_by,
  //         assisted_by:
  //           values?.assisted_by === "Other" ? null : values?.assisted_by,
  //         actual_opu_time: values?.actual_opu_time
  //           ? (values?.actual_opu_time).format("HH:mm:ss")
  //           : null,
  //         day_0_time: values?.day_0_time
  //           ? (values?.day_0_time).format("HH:mm:ss")
  //           : null,
  //         denudation_time: values?.denudation_time
  //           ? (values?.denudation_time).format("HH:mm:ss")
  //           : null,
  //         icsi_ivf_time: values?.icsi_ivf_time
  //           ? (values?.icsi_ivf_time).format("HH:mm:ss")
  //           : null,
  //         lmp: values?.lmp ? (values?.lmp).format("YYYY-MM-DD") : null,
  //         opu_date: values?.opu_date
  //           ? (values?.opu_date).format("YYYY-MM-DD")
  //           : null,
  //         opu_time: values?.opu_time
  //           ? (values?.opu_time).format("HH:mm:ss")
  //           : null,
  //         // sperms_by_donor: spermsByDetailDonor?._id,
  //         // sperms_by_name_donor: spermsByDetailDonor?.patient_full_name,
  //       };

  //       // if (Object.keys(embryologyData)?.length > 0) {
  //       //   dispatch(
  //       //     editEmbryologyData({
  //       //       location_id: selectedLocation,
  //       //       _id: embryologyDetails?._id,
  //       //       module_id: selectedModule?._id,
  //       //       payload: payloadObj,
  //       //     })
  //       //   );
  //       // } else {
  //       //   dispatch(
  //       //     createEmbryologyData({
  //       //       location_id: selectedLocation,
  //       //       patient_reg_id: selectedPatient?._id,
  //       //       module_id: selectedModule?._id,
  //       //       payload: payloadObj,
  //       //     })
  //       //   );
  //       // }
  //     } else {
  //       toast.error("IVF id Is Not Generated");
  //     }
  //   },
  //   [
  //     dispatch,
  //     embryologyData,
  //     selectedLocation,
  //     partnerDetailsEDS,
  //     patientDetailsEDS,
  //     selectedModule?._id,
  //     selectedPatient?._id,
  //     embryologyDetails?._id,
  //     embryologyDetails?.ivf_flow_id,
  //     eggsToDonorPatientList,
  //     eggsToPatientList,
  //     plannedCycleHasOD,
  //     IvfFlowsheetList?.planned_cycle,
  //   ]
  // );

  // const formik = useFormik({
  //   initialValues: procedureDetailsInitialData,
  //   validate: validateOocytes,
  //   validationSchema: oocyteTableSchema,
  //   validationContext: {
  //     plannedCycleHasODorED: plannedCycleHasODorED,
  //   },
  //   onSubmit: handleSubmitForm,
  // });

  // const {
  //   values,
  //   errors,
  //   touched,
  //   setValues,
  //   handleBlur,
  //   handleChange,
  //   handleSubmit,
  //   setFieldValue,
  //   setFieldError,
  // } = formik;

  // useImperativeHandle(ref, () => ({
  //   submitForm: () => formik.handleSubmit(),
  //   setFieldValue: formik.setFieldValue,
  //   formValues: formik.values,
  //   setValues: formik.setValues,
  // }));

  const disabledField = useCallback(
    (key) => {
      const cycleType = embryologyDetails?.cycle_type || "";

      const shouldDisableByMap = disabledFields[key]?.some((type) =>
        type === "FET+Surrogacy"
          ? cycleType.includes("FET") && cycleType.includes("Surrogacy")
          : cycleType.includes(type)
      );

      if (shouldDisableByMap) return true;

      return false;
    },
    [embryologyDetails?.cycle_type]
  );

  const handleProcedureDetailsChange = useCallback(
    (valuesObj) => {
      const data = {
        ...values,
        ...valuesObj,
      };

      setValues(data);
    },
    [setValues, values]
  );

  return (
    <div className="form_info_wrapper filled">
      <h3 className="mb-3">Procedure Details</h3>
      <ul className="grid_wrapper">
        <li className="w_270 w_xs_50">
          {/* <Form.Item
            label="Anesthesia Given by"
            // name="anesthesia_given_by"
            className="custom_select"
          > */}
          <div className="custom_select">
            <label htmlFor="">Anesthesia Given by</label>
            <Select
              showSearch
              mode="tags"
              maxCount={1}
              disabled={disabledField("anesthesia_given_by")}
              allowClear={true}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              // filterSort={(optionA, optionB) =>
              //   optionA.label
              //     .toLowerCase()
              //     .localeCompare(optionB.label.toLowerCase())
              // }
              placeholder="Select"
              name="anesthesia_given_by"
              value={values?.anesthesia_given_by}
              onChange={(value) => {
                handleProcedureDetailsChange({
                  anesthesia_given_by: value?.toString() || null,
                  anesthesia_given_by_other: "",
                });
              }}
              // options={anetheistNameOptions}
              options={moduleWiseDropdownData?.anesthesia_given_by}
              className="select_spacing_manage"
            />
          </div>
          {/* </Form.Item> */}
        </li>
        {values?.anesthesia_given_by === "Other" && (
          <li>
            {/* <Form.Item
              label="Anesthesia given by Other"
            // name="anesthesia_given_by_other"
            > */}
            <div className="custom_normal_input">
              <label htmlFor="">Anesthesia given by Other</label>
              <Input
                placeholder="Anesthesia given by Other"
                name="anesthesia_given_by_other"
                value={values?.anesthesia_given_by_other}
                onChange={(e) => {
                  setFieldValue(
                    "anesthesia_given_by_other",
                    e.target.value || null
                  );
                }}
              />
            </div>
            {/* </Form.Item> */}
          </li>
        )}
        <li className="w_270 w_xs_50">
          {/* <Form.Item
            label="OPU Done by"
            // name="opu_done_by"
            className="custom_select"
          > */}
          <div className="custom_select">
            <label htmlFor="">OPU Done by</label>
            <Select
              mode="tags"
              showSearch
              maxCount={1}
              disabled={disabledField("opu_done_by")}
              allowClear={true}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              // filterSort={(optionA, optionB) =>
              //   optionA.label
              //     .toLowerCase()
              //     .localeCompare(optionB.label.toLowerCase())
              // }
              placeholder="Select"
              name="opu_done_by"
              value={values?.opu_done_by}
              onChange={(value) => {
                const Obj = {
                  opu_done_by: value?.toString() || null,
                  opu_done_by_other:
                    values?.opu_done_by_other === "Other"
                      ? values?.opu_done_by_other
                      : null,
                };

                handleProcedureDetailsChange(Obj);
              }}
              // options={
              //   doctorList.length > 0
              //     ? [...doctorList, { label: "Other", value: "Other" }]
              //     : []
              // }
              options={moduleWiseDropdownData?.opu_done_by}
              className="select_spacing_manage"
            />
          </div>
          {/* </Form.Item> */}
        </li>
        {values?.opu_done_by === "Other" && (
          <li>
            {/* <Form.Item
              label="OPU done by Other"
            // name="opu_done_by_other"
            > */}
            <div className="custom_normal_input">
              <label htmlFor="">OPU done by Other</label>
              <Input
                placeholder="OPU done by Other"
                name="opu_done_by_other"
                value={values?.opu_done_by_other}
                onChange={(e) => {
                  setFieldValue("opu_done_by_other", e.target.value || null);
                }}
              />
            </div>
            {/* </Form.Item> */}
          </li>
        )}
        <li className="w_270 w_xs_50">
          {/* <Form.Item
            label="Tesa/Pesa Done by"
            // name="tesa_pesa_done_by"
          > */}
          <div className="custom_select">
            <label htmlFor="">Tesa/Pesa Done by</label>
            <Select
              showSearch
              mode="tags"
              maxCount={1}
              allowClear={true}
              disabled={disabledField("tesa_pesa_done_by")}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select"
              name="tesa_pesa_done_by"
              value={values?.tesa_pesa_done_by}
              onChange={(value) => {
                const Obj = {
                  tesa_pesa_done_by: value?.toString() || null,
                  tesa_pesa_done_by_other:
                    value === "Other" ? values.tesa_pesa_done_by_other : null,
                };

                handleProcedureDetailsChange(Obj);
              }}
              // options={
              //   doctorList.length > 0
              //     ? [...doctorList, { label: "Other", value: "Other" }]
              //     : []
              // }
              options={moduleWiseDropdownData?.tesa_pesa_done_by}
              className="select_spacing_manage"
            />
          </div>

          {/* </Form.Item> */}
        </li>
        {values?.tesa_pesa_done_by === "Other" && (
          <li>
            {/* <Form.Item
              label="Tesa/Pesa Done by Other"
            // name="tesa_pesa_done_by_other"
            > */}
            <div className="custom_normal_input">
              <label htmlFor="">Tesa/Pesa Done by Other</label>
              <Input
                placeholder="Tesa/Pesa Done by Other"
                name="tesa_pesa_done_by_other"
                value={values?.tesa_pesa_done_by_other}
                onChange={(e) => {
                  setFieldValue(
                    "tesa_pesa_done_by_other",
                    e.target.value || null
                  );
                }}
              />
            </div>
            {/* </Form.Item> */}
          </li>
        )}
        <li className="w_270 w_xs_50">
          {/* <Form.Item
            label="Denudation Done by"
            // name="denudation_done_by"
            className="custom_select"
          > */}
          <div className="custom_select">
            <label htmlFor="">Denudation Done by</label>
            <Select
              showSearch
              mode="tags"
              maxCount={1}
              allowClear={true}
              disabled={disabledField("denudation_done_by")}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select"
              name="denudation_done_by"
              value={values?.denudation_done_by}
              onChange={(value) => {
                const Obj = {
                  denudation_done_by: value?.toString() || null,
                  denudation_done_by_other: "",
                };

                handleProcedureDetailsChange(Obj);
              }}
              // options={denudationDoneByOptions}
              options={moduleWiseDropdownData?.denudation_done_by}
              className="select_spacing_manage"
            />
          </div>
          {/* </Form.Item> */}
        </li>
        {values?.denudation_done_by === "Other" && (
          <li>
            {/* <Form.Item
              label="Denudation Done by Other"
            // name="denudation_done_by_other"
            > */}
            <div className="custom_normal_input">
              <label htmlFor="">Denudation Done by Other</label>
              <Input
                placeholder="Denudation Done by Other"
                name="denudation_done_by_other"
                value={values?.denudation_done_by_other}
                onChange={(e) => {
                  setFieldValue(
                    "denudation_done_by_other",
                    e.target.value || null
                  );
                }}
              />
            </div>
            {/* </Form.Item> */}
          </li>
        )}
        {!plannedCycleHasOD && (
          <li className="w_270 w_xs_50">
            {/* <Form.Item
              label="ICSI Done by"
              // name="icsi_ivf_done_by"
              className="custom_select"
            > */}
            <div className="custom_select">
              <label htmlFor="">ICSI Done by</label>
              <Select
                showSearch
                mode="tags"
                maxCount={1}
                disabled={disabledField("icsi_ivf_done_by")}
                allowClear={true}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                // filterSort={(optionA, optionB) =>
                //   optionA.label
                //     .toLowerCase()
                //     .localeCompare(optionB.label.toLowerCase())
                // }
                placeholder="Select"
                name="icsi_ivf_done_by"
                value={values?.icsi_ivf_done_by}
                onChange={(value) => {
                  const Obj = {
                    icsi_ivf_done_by: value?.toString() || null,
                    icsi_ivf_done_by_other:
                      value === "Other" ? values.icsi_ivf_done_by_other : null,
                  };
                  handleProcedureDetailsChange(Obj);
                }}
                // options={
                //   doctorList.length > 0
                //     ? [...doctorList, { label: "Other", value: "Other" }]
                //     : []
                // }
                options={moduleWiseDropdownData?.icsi_ivf_done_by}
                className="select_spacing_manage"
              />
            </div>
            {/* </Form.Item> */}
          </li>
        )}
        {values?.icsi_ivf_done_by === "Other" && (
          <li className="w_220 w_xs_100">
            {/* <Form.Item
              label="ICSI Done by Other"
            // name="icsi_ivf_done_by_other"
            > */}
            <div className="custom_normal_input">
              <label htmlFor="">ICSI Done by Other</label>
              <Input
                placeholder="ICSI Done by Other"
                name="icsi_ivf_done_by_other"
                value={values?.icsi_ivf_done_by_other}
                onChange={(e) => {
                  setFieldValue(
                    "icsi_ivf_done_by_other",
                    e.target.value || null
                  );
                }}
              />
            </div>
            {/* </Form.Item> */}
          </li>
        )}
        <li className="w_270 w_xs_50">
          {/* <Form.Item
            label="Assisted by"
            // name="assisted_by"
            className="custom_select"
          > */}
          <div className="custom_select">
            <label htmlFor="">Assisted by</label>
            <Select
              showSearch
              mode="tags"
              maxCount={1}
              disabled={disabledField("assisted_by")}
              allowClear={true}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              // filterSort={(optionA, optionB) =>
              //   optionA.label
              //     .toLowerCase()
              //     .localeCompare(optionB.label.toLowerCase())
              // }
              placeholder="Select"
              name="assisted_by"
              value={values?.assisted_by}
              onChange={(value) => {
                const Obj = {
                  assisted_by: value?.toString() || null,
                  assisted_by_other:
                    value === "Other" ? values.assisted_by_other : null,
                };
                handleProcedureDetailsChange(Obj);
              }}
              // options={
              //   doctorList.length > 0
              //     ? [...doctorList, { label: "Other", value: "Other" }]
              //     : []
              // }
              options={moduleWiseDropdownData?.assisted_by}
              className="select_spacing_manage"
            />
          </div>
          {/* </Form.Item> */}
        </li>
        {values?.assisted_by === "Other" && (
          <li className="w_220 w_xs_100">
            {/* <Form.Item
              label="Assisted by Other"
            // name="assisted_by_other"
            > */}
            <div className="custom_normal_input">
              <label htmlFor="">Assisted by Other</label>
              <Input
                placeholder="Assisted by Other"
                name="assisted_by_other"
                value={values?.assisted_by_other}
                onChange={(e) => {
                  setFieldValue("assisted_by_other", e.target.value || null);
                }}
              />
            </div>
            {/* </Form.Item> */}
          </li>
        )}
      </ul>

      <EmbryologyEmbryoDevelopmentTable
        values={values}
        errors={errors}
        touched={touched}
        setValues={setValues}
        handleBlur={handleBlur}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        setFieldError={setFieldError}
      />
    </div>
  );
});

export default memo(EmbryologyProcedureDetails);
